import { loadStripe } from '@stripe/stripe-js';

// Check if authentication should be bypassed for development
const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';

// Initialize Stripe with your publishable key (only if key is provided and auth is not bypassed)
let stripePromise = null;

if (skipAuth) {
  // Skip Stripe initialization entirely when auth is bypassed
  stripePromise = Promise.resolve(null);
  console.log(
    'Stripe initialization skipped - authentication bypassed for development'
  );
} else {
  try {
    if (
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY &&
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY.trim() !== ''
    ) {
      stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    } else {
      console.log('Stripe publishable key not provided, using null promise');
      stripePromise = Promise.resolve(null);
    }
  } catch (error) {
    console.warn('Stripe initialization failed:', error);
    stripePromise = Promise.resolve(null);
  }
}

export default stripePromise;

// Stripe configuration
export const STRIPE_CONFIG = {
  // Subscription plans
  plans: {
    monthly: {
      priceId: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID,
      amount: 4999, // $50.00 in cents
      currency: 'usd',
      interval: 'month',
      name: 'Monthly Plan',
      description: 'Perfect for individual attorneys and small practices'
    },
    annual: {
      priceId: process.env.REACT_APP_STRIPE_ANNUAL_PRICE_ID,
      amount: 49999, // $500.00 in cents
      currency: 'usd',
      interval: 'year',
      name: 'Annual Plan',
      description: 'Best value - save 2 months with annual billing'
    }
  },

  // Trial settings
  trial: {
    days: 14,
    requiresPaymentMethod: true
  },

  // Success/cancel URLs
  urls: {
    success: `${window.location.origin}/app?payment=success`,
    cancel: `${window.location.origin}/app?payment=cancelled`
  }
};
